import { render, staticRenderFns } from "./PayeeState.vue?vue&type=template&id=6cc8c27c&"
import script from "./PayeeState.vue?vue&type=script&lang=ts&"
export * from "./PayeeState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports